module.exports = __webpack_public_path__ + "img/9791155922088.56a24ce0.jpg";